import { Body6 } from "@/src/components/typography/components/Body";
import { TextLink } from "../links/components/TextLink";
import { BLOCKS } from "@contentful/rich-text-types";
import { deserializeLineBreaks } from "@/src/helpers/contentfulRichTextStringSanitizer";
import type { Options } from "@contentful/rich-text-react-renderer";

/**
 * This is a small default mapping of Contentful rich text blocks to design system components
 * @see https://www.contentful.com/developers/docs/javascript/tutorials/rendering-contentful-rich-text-with-javascript/
 */
const DefaultRichTextComponentOptions: Options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <Body6 className="text-white">{children}</Body6>
    ),
    ["hyperlink"]: (node) => (
      <TextLink
        linkType="secondary"
        className="normal-case"
        href={node.data.uri}
      >
        {(node.content[0] as { value: string }).value}
      </TextLink>
    ),
  },
  // We use this transformer to ensure \n turn into <br /> elements
  renderText: (text) => deserializeLineBreaks(text),
};

export default DefaultRichTextComponentOptions;
